<script>
    import Register from "./Register.svelte";
    import Authorization from "./Authorization.svelte";
    import ConfirmEmail from "./Confirm-email.svelte";
    import { selectStep } from "/src/store";
    import { onMount } from "svelte";

    export let nextStep;

    function changeFormStep(step) {
        selectStep.set(step);
    }

    $: $selectStep;

    $: if (typeof window !== "undefined" && $selectStep) {
        window.dataLayer = window.dataLayer || [];

        if ($selectStep === "register") {
            // window.dataLayer.push({ event: "pre_registration" });
        } else if ($selectStep === "confirm-email") {
            window.dataLayer.push({ event: "pre_registration" });
        } else if ($selectStep === "authorization") {
            // window.dataLayer.push({ event: "login_succes" });
        }
    }
</script>

<svelte:head>
    <script src="https://challenges.cloudflare.com/turnstile/v0/api.js" async defer></script>
</svelte:head>

{#if $selectStep === "register"}
    <Register {changeFormStep} />
{:else if $selectStep === "authorization"}
    <Authorization {changeFormStep} {nextStep} />
{:else if $selectStep === "confirm-email"}
    <ConfirmEmail {nextStep} />
{/if}
